module.exports = __webpack_public_path__ + "static/img/niurenhui.30122e72.jpg";